var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-10" },
    [
      !_vm.isTalentMapping
        ? _c(
            "div",
            { staticClass: "flex flex-row justify-between h-12 mt-2.5" },
            [
              _c(
                "p",
                {
                  staticClass: "font-semibold w-max-content custom-title mt-1",
                },
                [_vm._v(" Our People ")]
              ),
              _c(
                "div",
                { staticClass: "inviteButton" },
                [
                  _c("InvitationSideBar", {
                    attrs: {
                      companyId: _vm.company.id,
                      currentUserId: _vm.currentUser.id,
                      companyBusinessName: _vm.company.business_name,
                      isManager: _vm.isManager,
                      actionButtonContent: "Invite",
                      size: "lg2",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("TabsWithRoutes", {
        staticClass: "mb-3",
        attrs: { routeTabs: _vm.routeTabs },
        on: { tabChanged: _vm.refetchRequestsContractorsNumber },
        scopedSlots: _vm._u(
          [
            _vm.showCondtractorsBubble
              ? {
                  key: _vm.routes.COMPANY_DATABASE_CONTRACTORS,
                  fn: function () {
                    return [
                      _c("span", { staticClass: "mr-1.5" }, [
                        _vm._v("Resources"),
                      ]),
                      _c("TabNotificationBubble", {
                        attrs: { notification: _vm.contractorsTotal, info: "" },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: _vm.routes.CONTRACTOR_FAV,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1.5" }, [_vm._v("Favorites")]),
                  _vm.favouriteTotal !== 0
                    ? _c("TabNotificationBubble", {
                        attrs: { notification: _vm.favouriteTotal, info: "" },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.showRequestsBubble
              ? {
                  key: _vm.routes.CONTRACTORS_REQUESTS,
                  fn: function () {
                    return [
                      _c("span", { staticClass: "mr-1.5" }, [
                        _vm._v("Requests"),
                      ]),
                      _c("TabNotificationBubble", {
                        attrs: { notification: _vm.getNumber, info: "" },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: _vm.routes.CONTRACTOR_PENDING,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1.5" }, [
                    _vm._v("Invite not sent"),
                  ]),
                  _vm.customPendingNumber !== 0
                    ? _c("TabNotificationBubble", {
                        attrs: {
                          notification: _vm.customPendingNumber,
                          info: "",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.CUSTOM_REQUESTS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1.5" }, [
                    _vm._v("Talent Hunt"),
                  ]),
                  _vm.customRequestsNumber !== 0
                    ? _c("TabNotificationBubble", {
                        attrs: {
                          notification: _vm.customRequestsTotal,
                          info: "",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.CONTRACTOR_ARCHIVED,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1.5" }, [_vm._v("Archived")]),
                  _vm.customArchiveNumber !== 0
                    ? _c("TabNotificationBubble", {
                        attrs: {
                          notification: _vm.customArhiveTotal,
                          info: "",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          canAddProject: "",
        },
        on: {
          refetchRequestsContractorsNumber:
            _vm.refetchRequestsContractorsNumber,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }